export const isErrorEvent = (event) => {
  return event instanceof ErrorEvent
}
